<template>
	<header class="page-header" v-sticky="{ fixedClass: 'page-header--fixed' }">
		<div class="page-header__nav">
			<router-link to="/"><img class="page-header__logo" alt="GoodHoodMusic" src="../assets/img/good-hood-music.svg"></router-link>
		</div>
	</header>
</template>

<script>
	import Sticky from '../directives/sticky.js';
	export default {
		name: 'PageHeader',
		directives: {
			Sticky
		},
		data() {
			return {
			}
		}
	}
</script>

<style>
</style>
